import classnames from 'classnames';
import type { FC } from 'react';
import React, { useContext } from 'react';

import {
  RicosAlignmentContext,
  RicosNodeContextProvider,
  VisibleIndentationContext,
  VisibleIndentationContextProvider,
} from './../../../../../ricos-context/index.js';
import { TextStyle_TextAlignment } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../../../../ricos-types/index.js';

import alignmentStyle from '../../../../statics/alignment-scss.js';
import styles from './lists-scss.js';

const OrderedList: FC<NodeViewRendererProps> = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { textAlignment } = useContext(RicosAlignmentContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);

  const currIndentation = visibleIndentation?.indentation || 0;
  const currOffset = node.orderedListData?.offset || 0;

  const indentation =
    (visibleIndentation && visibleIndentation?.nodeId !== node.id ? 1 : 0) +
    currIndentation +
    currOffset;

  const orderedListClassName = classnames(
    styles.orderedlist,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO]
  );

  return (
    <ol className={orderedListClassName} start={node.orderedListData?.start}>
      <VisibleIndentationContextProvider visibleIndentation={{ indentation, nodeId: node.id }}>
        <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
          <RicosNodesRenderer nodes={node.nodes ?? []} />
        </RicosNodeContextProvider>
      </VisibleIndentationContextProvider>
    </ol>
  );
};

const OrderedListRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <OrderedList key={node.id} node={node} {...props} />;
};

export default OrderedListRenderer;
